import React from "react"

import CSServiceUtil from "../../util/CSServiceUtil";
import CSRequestUtil from "../../util/CSRequestUtil"

import CSUtil from "../../util/CSUtil";
import CSFormUtil from "../../util/CSFormUtil"
import { cfGetConstantValue} from "../../util/CSConstantUtil";

class CSCOBaseDetailsForm extends React.Component
{

    constructor(props)
    {
       super(props);

        this.mCSUtil = CSUtil.cfGetInstance();
        this.mFormUtil = CSFormUtil.cfGetInstance();
        this.mCSServiceUtil = CSServiceUtil.cfGetInstance();

        this.state = 
        {
            mFeatureRefId               : this.props.pFeatureRefId,
            mAppId                      : this.props.pAppId,
            mNumSections                : 3,

            mSelectedMenuItem           : null,
            mFormCode           		: this.props.pFormCode,
            mFormHeading        		: (this.props.pFormHeading) ? this.props.pFormHeading : "",
            mDisplay                    : this.props.pShow,
            mFormLayoutHeading          : null,
            mParent                     : this.props.pParent,
            mFormData           		: (this.props.pFormData) ? this.props.pFormData : {},
            mFormOrigData       		: (this.props.pFormData) ? CSUtil.cfGetObjectCopy(props.pFormData) : {},
            mDataCollection             : null,
            mSectionData                : null,
            mSelectedData               : null,
            mSelectedActionItem         : null,
            mFormGrid                   : null,
            mFormActions                : null,
            mFormItems                  : this.props.pFormItems,
            mFormProperties             : this.props.pFormProperties,
            mFormValidation             : this.props.pFormValidation,
            mFormSelection              : this.props.pFormSelection,
            mFormActionProperties       : this.props.pFormActionProperties,
            mFormItemProperties         : this.props.pFormItemProperties,
            mFormItemComputation        : this.props.pFormItemComputation,
            mFormDetailsActions         : null,
            mFormItemsActions           : null,
            mGridHeading                : null,
            mAddFlag                    : false,
            mDetailsFlag                : false,
            mDetailsMetaData            : null,
            mSelectedRecord             : null,
            mIdFieldObjectMap           : {},
            mDataFieldObjectMap         : {},
            mWidth                      : this.props.pWidth,
            mHeight                     : this.props.pHeight,
            mShowBackdrop               : false,

            fnProcessChange             : this.props.fnProcessChange,
            fnProcessSubmit             : this.props.fnProcessSubmit,
            fnProcessClose              : this.props.fnProcessClose
        }

        this.process_search             = this.process_search.bind(this);
        this.process_add                = this.process_add.bind(this);
        this.process_modify             = this.process_modify.bind(this);
        this.process_delete             = this.process_delete.bind(this);
        this.process_details            = this.process_details.bind(this);
        this.process_close              = this.process_close.bind(this);

        this.cfGetFormHeading           = this.cfGetFormHeading.bind(this);
        this.cfGetFormItems             = this.cfGetFormItems.bind(this);
        this.cfProcessChange            = this.cfProcessChange.bind(this);
        this.cfCloseForm                = this.cfCloseForm.bind(this);

        this.cfProcessResponse          = this.cfProcessResponse.bind(this);
        this.cfSetFormData              = this.cfSetFormData.bind(this);
        this.cfInitializeLayout         = this.cfInitializeLayout.bind(this);
        this.cfSearch                   = this.cfSearch.bind(this);
        this.cfOnDataSelection          = this.cfOnDataSelection.bind(this);
        
        if(this.props.pFormProperties && this.props.pFormData)
        {
            for(var lInd_0=0; lInd_0<this.props.pFormProperties.length; lInd_0++)
            {
                var lFormProperty = this.props.pFormProperties[lInd_0];
                if(lFormProperty.type_ === 'initialize')
                {
                    if (lFormProperty.property_ === 'data_')
                    {
                        this.state.mSectionData = this.props.pFormData[lFormProperty.value_];
                    }
                    else if(lFormProperty.property_ === 'collection_data_')
                    {
                        this.state.mDataCollection = this.props.pFormData[lFormProperty.value_];
                    }
                }
            }
        }

        if(this.props.pFormActions)
        {
            for(var lInd=0; lInd<this.props.pFormActions.length; lInd++)
            {
                var lAction = this.props.pFormActions[lInd];
                if(lAction.component_type_ === 'DETAILS_ITEM_ACTION')
                {
                    if(!this.state.mFormItemsActions)
                    {
                        this.state.mFormItemsActions = [];
                    }

                    this.state.mFormItemsActions.push(lAction);
                }
                else
                {
                    if(!this.state.mFormActions)
                    {
                        this.state.mFormActions = [];
                    }

                    this.state.mFormActions.push(lAction);
                }
            }
        }
    }

    componentDidMount()
    {
        this.cfInitializeLayout();
    }

    componentDidUpdate(lPrevProps, lPrevState)
    {
        if(lPrevProps !== this.props)
        {
            this.cfInitializeLayout();
        }
    }

    cfInitializeLayout()
    {
        var lFormTitle = null;
        var lFormGrid = [];
        var lFormItemsActions = [];
        var lFormDetailsActions = [];
        var lGridHeading = null;

        var lSelectedActionItem = this.props.pSelectedActionItem;
        if(lSelectedActionItem)
        {
            lFormTitle = lSelectedActionItem.title_;
        }

        var lIdFieldObjectMap = {};
        var lDataFieldObjectMap = {};

        var lFormItemCollection = this.props.pFormItems;
        if(lFormItemCollection)
        {
            for (var lItemInd=0; lItemInd<lFormItemCollection.length; lItemInd++)
            {
                let lFormItem = lFormItemCollection[lItemInd];
                lIdFieldObjectMap[lFormItem.id_] = lFormItem;
                lDataFieldObjectMap[lFormItem.data_field_] = lFormItem;

                if(lFormItem.grid_display_ === '1')
                {
                    lFormItem.column_name_ = lFormItem.display_label_;
                    if(lFormItem.control_type_ === 'combo_box')
                    {
                        lFormItem.editable_ = '0';
                        lFormItem.item_editor_ = 'COMBO_BOX_EDITOR_1';
                        if(lFormItem.data_provider_source_)
                        {
                            this.mCSServiceUtil.cfGetDataFromDataProvider (lFormItem.data_provider_source_, 
                                (lDataProviderId, lCollection) => 
                                {
                                    if( lDataProviderId === lFormItem.data_provider_source_)
                                    {
                                        lFormItem.data_provider_ = lCollection;
                                    }
                                }
                            );
                        }
                    }
                    else if(lFormItem.control_type_ === 'date_field')
                    {
                        lFormItem.editable_ = '0';
                        lFormItem.item_editor_ = 'DATE_FIELD_EDITOR_1'
                    }

                    lFormGrid.push(lFormItem);
                }
                else if(this.state.mSectionData && this.state.mSectionData.hasOwnProperty(lFormItem.data_field_))
                {
                    lFormItem.mValue = this.state.mSectionData[lFormItem.data_field_]
                }

                if(lFormItem.control_type_ === 'collection')
                {
                    if(lFormItem.display_label_)
                    {
                        lGridHeading = lFormItem.display_label_;
                    }
                }
            }
        }

        var lFormActions = this.props.pFormActions;
        if(lFormActions)
        {
            for (var lActionInd=0; lActionInd<lFormActions.length; lActionInd++)
            {
                var lFormAction = lFormActions[lActionInd];
                if(lFormAction.component_type_ === 'DETAILS_ACTION')
                {
                    if(lFormAction.parent_ref_id_ && (this.props.pSelectedActionItem) && (lFormAction.parent_ref_id_ === this.props.pSelectedActionItem.id_))
                    {
                        lFormDetailsActions.push(lFormAction);
                    }
                }
                else if(lFormAction.component_type_ === 'DETAILS_ITEM_ACTION')
                {
                    if(!lFormAction.parent_ref_id_ || (lFormAction.parent_ref_id_ === this.props.pSelectedActionItem.id_))
                    {
                        lFormItemsActions.push(lFormAction);
                    }
                }
            }
        }

        if(lFormGrid)
        {
            CSUtil.cfSort(lFormGrid, 'sequence_')    
        }

        if(lFormItemsActions)
        {
            CSUtil.cfSort(lFormItemsActions, 'sequence_')          
        }

        if(lFormDetailsActions)
        {
            CSUtil.cfSort(lFormDetailsActions, 'sequence_')
        }

        this.setState(
            {
                mFormLayoutHeading      : lFormTitle,
                mFormGrid               : lFormGrid,
                mFormItemsActions       : lFormItemsActions,
                mFormDetailsActions     : lFormDetailsActions,
                mGridHeading            : lGridHeading,
                mDataFieldObjectMap     : lDataFieldObjectMap,
                mIdFieldObjectMap       : lIdFieldObjectMap
            }
        );
    }

    cfGetFormHeading(lActionId)
    {
        var lFormTitle;
        if(lActionId !== null)
        {
            for(var lInd=0; lInd < this.state.mFormActions.length; lInd++)
            {
                var lFormAction = this.state.mFormActions[lInd];
                if(lFormAction.id_ === lActionId)
                {
                    lFormTitle = lFormAction.title_;
                    break;
                }
            }
        }

        return lFormTitle;
    }

    cfSetFormData(lCollection)
    {
        if(this.props !== null)
        {
            var lMenuItem = this.mCSUtil.cfGetMenuItem(this.props.pFeatureRefId);
            if(lMenuItem != null)
            {
                var lSearchActionsList = [];
                var lFormActions = this.props.pFormActions;
                if((lFormActions !== undefined) && (lFormActions !== null))
                {
                    for(var ind=0; ind<lFormActions.length; ind++)
                    {
                        if(lFormActions[ind].component_type_ === 'SEARCH_ACTION')
                        {
                            lSearchActionsList.push(lFormActions[ind]);
                        }
                    }
                }

                this.setState(
                    {
                        mFeatureRefId           : this.props.pFeatureRefId,
                        mSelectedMenuItem       : lMenuItem,
                        mSelectedActionItem     : null,
                        mParent                 : this.props.pParent,
                        mFormActions            : this.props.pFormActions,
                        mFormItems              : this.props.pFormItems,
                        mFormGrid               : this.props.pFormGrid,
                        mFormProperties         : this.props.pFormProperties,
                        mFormValidation         : this.props.pFormValidation,
                        mFormSelection          : this.props.pFormSelection,
                        mFormActionProperties   : this.props.pFormActionProperties,
                        mFormGridProperties     : this.props.pFormGridProperties,
                        mFormGridItemProperties : this.props.pFormGridItemProperties,
                        mFormItemProperties     : this.props.pFormItemProperties,
                        mFormItemComputation    : this.props.pFormItemComputation,
                        mSearchActionList       : lSearchActionsList,
                        mDataCollection         : lCollection
                    }
                );
            }
        }
    }

    process_search(lCriteria, lActionItem)
    {
        this.setState({mCriteria : lCriteria, mActionItem : lActionItem});
        if((lActionItem !== undefined) && (lActionItem !== null) && (lActionItem.on_click_service_code_ !== null))
        {
            this.cfSearch(lActionItem.on_click_service_code_, lCriteria);
        }
    }

    cfSearch(lServiceCode, lCriteria)
    {
        if(lServiceCode !== null)
        {
            var lServiceObject = this.mCSServiceUtil.cfGetServiceObject(lServiceCode);
            if(lServiceObject !== null)
            {
                var lCriteriaObj = (lCriteria) ? lCriteria : {};
                var lRequestUtil = new CSRequestUtil('GET', lServiceCode, lServiceObject.type_, null, lServiceObject);
                if(lServiceObject.hasOwnProperty('cs_service_properties_'))
                {
                    var lServiceProperties = lServiceObject.cs_service_properties_;
                    if(lServiceProperties !== null)
                    {
                        for(var lInd=0; lInd<lServiceProperties.length; lInd++)
                        {
                            lCriteriaObj[lServiceProperties[lInd].property_] = cfGetConstantValue(lServiceProperties[lInd].value_);
                        }
                    }
                }
                
                lRequestUtil.cfSetRequestCriteria(lCriteriaObj);
                lRequestUtil.cfProcessRequest(this.cfProcessResponse);
            }
        }
    }

    process_add(event, lParent, lActionItem)
    {
        if(event && event.currentTarget && lParent && lActionItem)
        {
            event.preventDefault();
            var lActions = null;
            for(var lInd=0; lInd<this.state.mFormItemsActions.length; lInd++)
            {
                var lAction = this.state.mFormItemsActions[lInd];
                if(lAction.parent_ref_id_ === event.currentTarget.id)
                {
                    if(!lActions)
                    {
                        lActions = [];
                    }

                    lActions.push(lAction);
                }
            }

            var lDetailsMetaData = 
            {
                pAppId                  : this.state.mAppId,
                pFormType               : lActionItem.navigate_to_form_component_code_,
                pFormHeading            : lActionItem.title_,
                pFormActions            : CSUtil.cfSort(lActions, 'sequence_'),
                pFormProperties         : this.state.mFormProperties,
                pFormItems              : this.cfGetFormItems(event.currentTarget.id),
                pFormItemProperties     : this.state.mFormItemProperties,
                pFormItemComputation    : this.state.mFormItemComputation,
                pFormSelection          : this.state.mFormSelection,
                pFormValidation         : this.state.mFormValidation
            };

            this.setState(
                {
                    mAddFlag             : true,
                    mDetailsMetaData     : lDetailsMetaData,
                    mDetailsFlag         : true,
                    mSelectedActionItem  : lActionItem
                }
            );
        }
    }

    process_modify(event, lParent, lActionItem)
    {
        if(event && event.currentTarget && lActionItem)
        {
            event.preventDefault();
            var lActions = [];
            for(var lInd=0; lInd<this.state.mFormActions.length; lInd++)
            {
                var lAction = this.state.mFormActions[lInd];
                if((lAction.component_type_ === 'DETAILS_ITEM_ACTION') && (lAction.parent_ref_id_ === event.currentTarget.id))
                {
                    lActions.push(lAction);
                }
            }
            
            var lDetailsMetaData = 
            {
                pAppId                  : this.state.mAppId,
                pFormType               : lActionItem.navigate_to_form_component_code_,
                pFormHeading            : lActionItem.title_,
                pFormActions            : CSUtil.cfSort(lActions, 'sequence_'),
                pFormProperties         : this.state.mFormProperties,
                pFormItems              : this.cfGetFormItems(event.currentTarget.id),
                pFormItemProperties     : this.state.mFormItemProperties,
                pFormItemComputation    : this.state.mFormItemComputation,
                pFormSelection          : this.state.mFormSelection,
                pFormValidation         : this.state.mFormValidation
            };

            if(this.state.mSelectedRecord)
            {
                var lDataObj = {};
                lDataObj.selected_data_ = this.state.mSelectedRecord;
                this.setState(
                    {
                        mAddFlag             : false,
                        mDetailsMetaData     : lDetailsMetaData,
                        mDetailsFlag         : true,
                        mSelectedData        : lDataObj,
                        mSelectedActionItem  : lActionItem
                    }
                );
            }
        }
    }

    process_details(event, lParent, lActionItem)
    {
        if(event && event.currentTarget && lParent && lActionItem)
        {
            event.preventDefault();
            var lActions = [];
            for(var lInd=0; lInd<this.state.mFormActions.length; lInd++)
            {
                var lAction = this.state.mFormActions[lInd];
                if((lAction.component_type_ === 'DETAILS_ITEM_ACTION') && (lAction.parent_ref_id_ === event.currentTarget.id))
                {
                    lActions.push(lAction);
                }
            }

            var lDetailsMetaData = 
            {
                pAppId                  : this.state.mAppId,
                pFormType               : lActionItem.navigate_to_form_component_code_,
                pFormHeading            : lActionItem.title_,
                pFormActions            : CSUtil.cfSort(lActions, 'sequence_'),
                pFormProperties         : this.state.mFormProperties,
                pFormItems              : this.cfGetFormItems(event.currentTarget.id),
                pFormItemProperties     : this.state.mFormItemProperties,
                pFormItemComputation    : this.state.mFormItemComputation,
                pFormSelection          : this.state.mFormSelection,
                pFormValidation         : this.state.mFormValidation
            };

            if(this.state.mSelectedRecord)
            {
                var lDataObj = {};
                lDataObj.selected_data_ = this.state.mSelectedRecord;
                this.setState(
                    {
                        mAddFlag            : false,
                        mDetailsMetaData    : lDetailsMetaData,
                        mDetailsFlag        : true,
                        mSelectedData       : lDataObj,
                        mSelectedActionItem : lActionItem
                    }
                );
            }
        }
    }

    process_delete(event, lParent)
    {
        if(this.state.mParent && this.state.mParent.hasOwnProperty('process_delete'))
        {
            this.state.mParent.process_delete(event, lParent);
        }
    }

    cfProcessResponse(response)
    {
        var lCollection = [];
        if((response != null) && response.hasOwnProperty("result") && response.result.hasOwnProperty("collection_") )
        {
            if( (response.result.collection_ !== undefined) || (response.result.collection_ !== null))
            {
                if(response.result.collection_ instanceof Array)
                {
                    lCollection = response.result.collection_;
                }
                else
                {
                    lCollection.push(response.result.collection_);
                }
            }
        }

        this.cfSetFormData(lCollection);
    }

    cfCloseForm(lDetailsFlag)
    {
        this.setState({ mDetailsFlag : lDetailsFlag });
    }

    process_close(lEvent, lParent, lActionItem)
    {
        if(this.state.fnProcessClose)
        {
            this.state.fnProcessClose(lEvent, lParent, lActionItem);
        }
    }

    cfOnDataSelection(sel_data)
    {
        if(sel_data)
        {
            this.setState({mSelectedRecord : sel_data});
        }
    }

    cfProcessChange(lData)
    {
        if(lData)
        {
            var lFormData = null;
            if(this.state.mFormData)
            {
                lFormData = this.state.mFormData;
            }
            else
            {
                lFormData = {};
            }

            lFormData[lData.data_field_] = lData.value_;
            this.setState ({mFormData : lFormData});        
        }
    }

    cfGetFormItems(lActionId)
    {
        var lFormItems = [];
        if(lActionId !== null)
        {
            for(var lInd=0; lInd < this.state.mFormItems.length; lInd++)
            {
                var lFormItem = this.state.mFormItems[lInd];
                if(lFormItem.grid_display_ === '1')
                {
                    lFormItems.push(lFormItem);
                }
            }
        }
        
        return lFormItems;
    }

    componentWillUnmount()
    {
        this.props = null;
    }
}

export default CSCOBaseDetailsForm;
